import { render } from "./COIList.vue?vue&type=template&id=7201efd9"
import script from "./COIList.vue?vue&type=script&lang=js"
export * from "./COIList.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__